import type { IGatsbyImageData } from 'gatsby-plugin-image'

export const ImageLayout = {
  none: 'none',
  cover: 'cover',
  contain: 'contain',
}

interface Image {
  alt: string | null
  url?: string | null
  gatsbyImageData?: IGatsbyImageData | null
}

export default Image
